export const PAGE_SIZES = [10, 20, 50];
